import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { RootState } from "../../store";
import { getClasses, sanitizedHtml } from "../../utils";
import classes from "./Registration.module.css";
import GuidelineCard from "./GuidelineCard";
import PrimaryButton from "../../components/Buttons/PrimaryButton";
import ResendOrderLink from "./ResendOrderLink";
import guidelineBackgroundImage1 from "../../assets/guideline-background-1.svg";
import guidelineBackgroundImage2 from "../../assets/guideline-background-2.svg";
import EventCalendar from "../EventCalendar/EventCalendar";

const BASE = "/api";

type Props = {};

const Registration: React.FC<Props> = () => {
  const {
    id,
    introHeading,
    introContent,
    heroImage,
    eventGuidelines,
    updateTime,
  } = useSelector((state: RootState) => state.pod.pod);
  const resourceName = useSelector(
    (state: RootState) => state.pod.resourceName
  );
  const language = useSelector((state: RootState) => state.language.language);
  const [showResendOrderLink, setShowResendOrderLink] = useState(false);
  const searchParams = new URLSearchParams(window.location.search);
  const patientId = searchParams.get("p_id");
  const token = searchParams.get("t_id");

  useEffect(() => {
    if (token && patientId && localStorage.getItem("patientData")) {
      localStorage.removeItem("patientData");
      localStorage.removeItem("isPatientPortalData");
    }
  }, [token, patientId]);

  const patientPortalHandler = () => {
    window.open("https://my.reya.net", "_blank", "noopener,noreferrer");
  };

  const filtered = eventGuidelines.filter((e) => {
    return e.heading !== "";
  });

  return (
    <>
      {showResendOrderLink && (
        <ResendOrderLink onClose={() => setShowResendOrderLink(false)} />
      )}
      <div className={classes.container}>
        <div
          className={getClasses(
            classes.header,
            language === "ar"
              ? classes.rtlDirBackground
              : classes.ltrDirBackground
          )}>
          <div className={classes.content}>
            <div className={classes.leftContent}>
              <div>
                <h1
                  className={classes.title}
                  dangerouslySetInnerHTML={{
                    __html: sanitizedHtml(introHeading),
                  }}></h1>
                <p
                  className={classes.subtitle}
                  dangerouslySetInnerHTML={{
                    __html: sanitizedHtml(introContent),
                  }}></p>
              </div>
              <PrimaryButton
                className={classes.portalAction}
                name='Patient Portal'
                onClick={patientPortalHandler}
              />
            </div>
            <div className={classes.rightContent}>
              {heroImage && (
                <img
                  src={`${BASE}${heroImage}?${updateTime}&tenantId=${resourceName}`}
                  alt=''
                  className={classes.logo}
                  width={300}
                  height={120}
                />
              )}
            </div>
          </div>
        </div>
        <div className={classes.bannerContainer}>
          <div className={classes.textContainer}>
            <div
              className={classes.heading}
              dangerouslySetInnerHTML={{
                __html: sanitizedHtml(introHeading),
              }}></div>
            <div
              className={classes.introContent}
              dangerouslySetInnerHTML={{
                __html: sanitizedHtml(introContent),
              }}></div>
            <div className={classes.actionsContainer}>
              <PrimaryButton
                className={classes.action}
                name='Patient Portal'
                onClick={patientPortalHandler}
              />
            </div>
          </div>
          <div className={classes.imgContainer}>
            <div>
              {heroImage && (
                <img
                  src={`${BASE}${heroImage}?${updateTime}&tenantId=${resourceName}`}
                  alt=''
                />
              )}
            </div>
          </div>
        </div>
        {filtered.length > 0 ? (
          <div className={classes.guidelineContainer} id='guidelines'>
            <div className={classes.guide}>
              {filtered.map((item, idx) => (
                <GuidelineCard
                  style={{
                    backgroundImage: `url(${
                      idx % 2 === 0
                        ? guidelineBackgroundImage1
                        : guidelineBackgroundImage2
                    })`,
                    backgroundPosition: `${
                      idx % 2 === 0 ? "-14% 105%" : "106% -10%"
                    }`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: idx % 2 === 0 ? "7rem" : "4.5rem",
                  }}
                  key={idx}
                  data={item}
                />
              ))}
            </div>
          </div>
        ) : (
          <></>
        )}
        <div>
          <EventCalendar />
        </div>
        <div className={classes.resendContainer}>
          <div className={classes.ticket}>If you already ordered a ticket</div>
          <div className={classes.resendDescription}>
            Click on the button below if you want to modify the status and
            specifics of your order.
          </div>
          <div className={classes.primaryBtn}>
            <PrimaryButton
              name='RESEND ORDER LINKS'
              onClick={() => setShowResendOrderLink(true)}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default Registration;
